


<mat-dialog-content>
  <h2 mat-dialog-title *ngIf="data.title" style="margin: 0px;">{{data.title}}</h2>
  <p>{{data.message}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="-align-center" mat-raised-button mat-button mat-dialog-close tabindex="-1"><span>OK</span></button>
</mat-dialog-actions>

